export function hoursInputToMinutes(hoursInput: string | null): number | null {
  if (!hoursInput) return null;
  if (!hoursInput.includes(':')) return null;

  const [h, m] = hoursInput.split(':');
  const hours = parseInt(h);
  const minutes = parseInt(m);

  if (isNaN(hours) || isNaN(minutes)) return null;

  return hours * 60 + minutes;
}
